import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PersistedTicketAttachment } from '@proto/hubspotr';

@Component({
  selector: 'app-conversation-attachments',
  templateUrl: './conversation-attachments.component.html',
  standalone: false
})
export class ConversationAttachmentsComponent {

  @Input()
  public attachments: PersistedTicketAttachment[];

  @Output()
  public onAttachmentClicked = new EventEmitter<PersistedTicketAttachment>();

  onAttachmentClick(attachment: PersistedTicketAttachment) {
    this.onAttachmentClicked.emit(attachment);
  }

}
